import { useState } from 'react'

import { initRequestParam } from 'constants/constants'

import { getAPI } from 'utils/getAPI'

import { useCurrentStatusStore } from '../store/currentStatusStore'

import type { GetInfomessageInfomessageGetRequest, InfoMessageList, ResponseResult } from 'api-client'
import type { ErrorResponse } from 'types/types'

export const useInfoMessage = () => {
  const [infomessage, setInfomessaeg] = useState<InfoMessageList>({
    datacount: 0,
    maxcount: 0,
    lastUpdateDatetime: null,
    list: [],
  })
  const [result, setResult] = useState<ResponseResult | undefined>(undefined)
  const [isLoading, setIsLoading] = useState(false)

  const { setCurrentStatuses } = useCurrentStatusStore()

  const fetchInfomessage = async (searchParam: GetInfomessageInfomessageGetRequest) => {
    setInfomessaeg(initRequestParam)
    setResult(undefined)
    setIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.getInfomessageInfomessageGet(searchParam)

      setInfomessaeg(response.data)
      setResult(response.result)
      setCurrentStatuses(response.result.systemInfo?.sysCurrentStatus)
      return response
    } catch (e) {
      const error = e as ErrorResponse
      setResult({
        status: 'error',
        message: error.response && error.response.status === 422 ? '入力値に誤りがあります。' : `情報メッセージ取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
      return undefined
    } finally {
      setIsLoading(false)
    }
  }

  return {
    infomessage,
    result,
    fetchInfomessage,
    isLoading,
  }
}
